var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M12.8,5.2H8L6.8,4H3.2A1.2,1.2,0,0,0,2.006,5.2L2,12.4a1.2,1.2,0,0,0,1.2,1.2H13.262A.741.741,0,0,0,14,12.862V6.4A1.2,1.2,0,0,0,12.8,5.2Zm0,7.2H3.2V5.2H6.3L7.5,6.4h5.3ZM11.6,8.8H4.4V7.6h7.2ZM9.2,11.2H4.4V10H9.2Z",
    transform: "translate(-2 -4)",
    fill: "#3281ac"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/Activity.e1c145f69338043b81b209d74728e1aa.svg";
export { ForwardRef as ReactComponent };